<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="`${$t('Utilities_Title')} > ${$t('LeftPanel_subtitle_lonjas')}`" />
    <f7-block class="content-devx">
      <SlicesComponent />
      <f7-row>
        <f7-col />
        <f7-col class="justify-content-end">
          <f7-button
            class="dx-btn-success button-margin-right"
            raised
            type="success"
            styling-mode="contained"
            @click="addSeriesGraphic"
          >
            {{ $t("Button_add_weather") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
    <GraphicProductComponent
      v-if="loaded"
      :date="date"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SlicesComponent from '../../../components/utilities/slices/index.vue';
import GraphicProductComponent from '../../../components/utilities/slices/graphicProduct/index.vue';
import navbar from '../../../components/NavBar.vue';

export default {
  name: 'Slices',
  components: {
    SlicesComponent,
    navbar,
    GraphicProductComponent,
  },
  data() {
    return {
      visible: false,
      date: [],
      loaded: false,
    };
  },
  computed: {
    ...mapState('Slices', ['initDate', 'endDate', 'SelectedSlices', 'SelectedFamily', 'SelectedProduct',
      'dataDate', 'SelectedOrigin']),
  },
  beforeMount() {
  },
  methods: {
    beforein() {
      this.$fa.setScreenName('Utilidades > Lonjas');
    },
    async addSeriesGraphic() {
      this.loaded = false;
      if (this.campaign === '') {
        this.$notifyDX(
          {
            message: this.$t('DxRegisterCampania_init_date_require'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.initDate === '' || this.initDate === 'Invalid date') {
        this.$notifyDX(
          {
            message: this.$t('DxRegisterCampania_fecha_inicio_validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.endDate === '' || this.endDate === 'Invalid date') {
        this.$notifyDX(
          {
            message: this.$t('DxRegisterCampania_fecha_finalizacion_validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.initDate > this.endDate) {
        this.$notifyDX(
          {
            message: this.$t('DxRegisterCampania_fecha_inicio_mayor_validation'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.SelectedSlices === '') {
        this.$notifyDX(
          {
            message: this.$t('Slices_validate_slice'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.SelectedFamily === '') {
        this.$notifyDX(
          {
            message: this.$t('Slices_validate_family'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.SelectedProduct === '') {
        this.$notifyDX(
          {
            message: this.$t('Slices_validate_product'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.SelectedOrigin === '') {
        this.$notifyDX(
          {
            message: this.$t('Slices_validate_origin'),
            width: 550,
          },
          'info',
          3000,
        );
      } else {
        try {
          this.$f7.preloader.show();
          await this.getData();
          this.date = this.dataDate;
          this.loaded = true;
        } catch (reason) {
          const message = this.$helpers.getFilteredErrorMessage(reason);
          if (message.includes('default_') && !message.includes('404')) {
            this.$notifyDX(
              {
                message: message.split('_').pop(),
                width: 550,
              },
              'error',
              3000,
            );
          } else if (!message.includes('404')) {
            this.$notifyDX(
              {
                message: this.$t(message),
                width: 550,
              },
              'error',
              3000,
            );
          }
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
    ...mapActions('Slices', ['getData']),
  },
};
</script>
<style scoped>
@import './slices.styles.scss';
</style>
